/**
 * Feature Bundle Data
 * Curated packages with visual mockups
 */
export const BUNDLES = [
    {
        id: 'essential-starter',
        name: 'Essential Starter',
        tagline: 'Everything you need to launch professionally',
        description: 'Core functionality with security, trust building, and lead generation. Your complete foundation.',
        perfectFor: 'New platform launch, MVP, getting started quickly',
        timeline: '4-6 weeks',
        investment: 'Low',
        featureIds: [
            'price-calculator',
            'advanced-search',
            'virtual-consultation',
            'wishlist-collections',
            'two-factor-auth',
            'cert-verification',
            'email-capture',
            'social-proof'
        ],
        features: [
            { name: 'Diamond Price Calculator', benefit: 'Build trust through transparency' },
            { name: 'Advanced Search & Filtering', benefit: 'Customers find diamonds faster' },
            { name: 'Virtual Consultation Booking', benefit: 'Convert browsers to leads' },
            { name: 'Wishlist & Collections', benefit: 'Keep customers engaged' },
            { name: 'Two-Factor Authentication', benefit: 'Secure accounts' },
            { name: 'Certificate Verification', benefit: 'Verify authenticity instantly' },
            { name: 'Email Capture Popups', benefit: 'Build your email list' },
            { name: 'Social Proof Widgets', benefit: 'Boost conversions' }
        ],
        mockupType: 'checklist',
        color: '#3b82f6',
        gradient: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)'
    },
    {
        id: 'dealer-operations',
        name: 'Dealer Operations Suite',
        tagline: 'Complete B2B wholesale infrastructure',
        description: 'Everything serious wholesale operations need: credit, memos, payments, tracking, and loyalty.',
        perfectFor: 'Established wholesale business, serious B2B operations',
        timeline: '8-12 weeks',
        investment: 'High',
        featureIds: [
            'credit-limit-management',
            'net-payment-terms',
            'credit-application',
            'memo-tracking',
            'dealer-performance-analytics',
            'automated-invoicing',
            'order-management',
            'dealer-dashboard',
            'bulk-purchase-discounts',
            'dealer-loyalty-tiers'
        ],
        features: [
            { name: 'Credit Limit Management', benefit: 'Enable larger purchases' },
            { name: 'NET 30/60/90 Terms', benefit: 'Industry-standard billing' },
            { name: 'Online Credit Application', benefit: 'Professional onboarding' },
            { name: 'Memo Return Tracking', benefit: 'Never lose inventory' },
            { name: 'Dealer Analytics', benefit: 'Know your top partners' },
            { name: 'Automated Invoicing', benefit: 'Save hours weekly' },
            { name: 'Order Management', benefit: 'Track every sale' },
            { name: 'Dealer Dashboard', benefit: 'Self-service portal' },
            { name: 'Bulk Discounts', benefit: 'Encourage larger orders' },
            { name: 'Loyalty Tiers', benefit: 'Reward top dealers' }
        ],
        mockupType: 'dashboard',
        color: '#10b981',
        gradient: 'linear-gradient(135deg, #10b981 0%, #14b8a6 100%)'
    },
    {
        id: 'ai-automation',
        name: 'AI & Automation Powerhouse',
        tagline: 'Work smarter, not harder with AI',
        description: 'Let artificial intelligence handle repetitive tasks, make predictions, and optimize pricing automatically.',
        perfectFor: 'Scaling operations, reducing manual work, efficiency gains',
        timeline: '10-14 weeks',
        investment: 'Very High',
        featureIds: [
            'ai-matchmaker',
            'ai-chatbot',
            'predictive-alerts',
            'auto-repricing',
            'email-automation',
            'automated-followup',
            'smart-inventory',
            'demand-forecasting',
            'memo-extension-auto-approval'
        ],
        features: [
            { name: 'AI Diamond Matchmaker', benefit: 'Personalized recommendations' },
            { name: 'AI Chatbot', benefit: '24/7 instant support' },
            { name: 'Predictive Price Alerts', benefit: 'Buy before price drops' },
            { name: 'Auto-Repricing', benefit: 'Always competitive' },
            { name: 'Email Automation', benefit: 'Recover lost sales' },
            { name: 'Auto Follow-Up', benefit: 'Perfect timing' },
            { name: 'Smart Inventory', benefit: 'AI tells you what to buy' },
            { name: 'Demand Forecasting', benefit: 'Predict trends' },
            { name: 'Memo Auto-Approval', benefit: 'Instant dealer satisfaction' }
        ],
        mockupType: 'network',
        color: '#ec4899',
        gradient: 'linear-gradient(135deg, #ec4899 0%, #a855f7 100%)'
    },
    {
        id: 'premium-experience',
        name: 'Premium Experience Package',
        tagline: 'Luxury technology for high-end positioning',
        description: 'Cutting-edge AR, VR, 3D visualization, and custom design tools that wow luxury clients.',
        perfectFor: 'Luxury market, high-end retail, premium brand positioning',
        timeline: '16-20 weeks',
        investment: 'Very High',
        featureIds: [
            'ar-try-on',
            'vr-showroom',
            'custom-jewelry-builder',
            'video-library',
            'diamond-scanner',
            'custom-cut-designer-public',
            'white-label-catalogs',
            'virtual-trade-show-booth'
        ],
        features: [
            { name: 'AR Virtual Try-On', benefit: 'See diamonds on hand via camera' },
            { name: 'VR Showroom', benefit: 'Immersive virtual experience' },
            { name: 'Custom Jewelry Builder', benefit: 'Interactive ring design' },
            { name: 'Diamond Video Library', benefit: '360° video views' },
            { name: '3D Scanner Upload', benefit: 'Verify authenticity' },
            { name: 'Custom Cut Designer', benefit: 'Design unique cuts' },
            { name: 'White-Label Catalogs', benefit: 'Branded dealer materials' },
            { name: 'Virtual Trade Show', benefit: 'Always-on exhibition' }
        ],
        mockupType: 'mobile',
        color: '#a855f7',
        gradient: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)'
    },
    {
        id: 'marketplace-community',
        name: 'Marketplace & Community',
        tagline: 'Build a dealer ecosystem and network effects',
        description: 'Platform features that let dealers trade with each other, creating a thriving marketplace.',
        perfectFor: 'Platform play, network effects, dealer ecosystem building',
        timeline: '14-18 weeks',
        investment: 'Very High',
        featureIds: [
            'private-dealer-marketplace',
            'dealer-diamond-swaps',
            'b2b-auction-platform',
            'live-wholesale-bidding',
            'dealer-collaboration-custom',
            'joint-venture-opportunities',
            'shared-inventory-pools'
        ],
        features: [
            { name: 'Private Dealer Marketplace', benefit: 'Dealers trade with each other' },
            { name: 'Diamond Exchange', benefit: 'Peer-to-peer swaps with escrow' },
            { name: 'B2B Auction Platform', benefit: 'Wholesale lot auctions' },
            { name: 'Live Bidding', benefit: 'Dutch auction excitement' },
            { name: 'Large Order Collaboration', benefit: 'Co-invest in expensive pieces' },
            { name: 'Joint Ventures', benefit: 'Strategic partnerships' },
            { name: 'Shared Inventory Pools', benefit: 'Co-op buying power' }
        ],
        mockupType: 'network',
        color: '#0ea5e9',
        gradient: 'linear-gradient(135deg, #0ea5e9 0%, #06b6d4 100%)'
    },
    {
        id: 'quick-wins',
        name: 'Quick Wins Package',
        tagline: 'Fast results, immediate ROI, low risk',
        description: '12 low-complexity features that can be implemented quickly and show immediate business value.',
        perfectFor: 'Fast results, testing the waters, low-risk investment',
        timeline: '2-4 weeks',
        investment: 'Low',
        featureIds: [
            'virtual-consultation',
            'wishlist-collections',
            'bulk-operations',
            'two-factor-auth',
            'ip-whitelisting',
            'social-auto-post',
            'email-capture',
            'content-cms',
            'google-shopping',
            'retargeting-pixels',
            'diamond-quiz',
            'seasonal-promos'
        ],
        features: [
            { name: 'Consultation Booking', benefit: '1-week implementation' },
            { name: 'Wishlist System', benefit: 'Customer retention' },
            { name: 'Bulk Operations', benefit: 'Save time' },
            { name: 'Two-Factor Auth', benefit: 'Secure accounts' },
            { name: 'IP Whitelisting', benefit: 'Enhanced security' },
            { name: 'Social Auto-Post', benefit: 'Consistent presence' },
            { name: 'Email Capture', benefit: 'Build list' },
            { name: 'Blog/CMS', benefit: 'SEO benefits' },
            { name: 'Google Shopping', benefit: 'New traffic' },
            { name: 'Retargeting Pixels', benefit: 'Recover visitors' },
            { name: 'Diamond Quiz', benefit: 'Engagement' },
            { name: 'Seasonal Promos', benefit: 'Holiday sales' }
        ],
        mockupType: 'lightning',
        color: '#22c55e',
        gradient: 'linear-gradient(135deg, #22c55e 0%, #10b981 100%)'
    },
    {
        id: 'data-insights',
        name: 'Data & Insights Pro',
        tagline: 'Business intelligence and competitive analytics',
        description: 'See the past, understand the present, predict the future with comprehensive analytics.',
        perfectFor: 'Data-driven decisions, competitive intelligence, optimization',
        timeline: '8-10 weeks',
        investment: 'High',
        featureIds: [
            'market-trends',
            'customer-behavior',
            'inventory-performance',
            'competitor-monitoring',
            'demand-forecasting',
            'customer-ltv',
            'sales-dashboard'
        ],
        features: [
            { name: 'Market Trends Dashboard', benefit: 'See price movements' },
            { name: 'Behavior Analytics', benefit: 'Understand customer actions' },
            { name: 'Inventory Performance', benefit: 'Know what sells' },
            { name: 'Competitor Monitoring', benefit: 'Stay competitive' },
            { name: 'Demand Forecasting', benefit: 'Predict what will sell' },
            { name: 'Lifetime Value Tracker', benefit: 'Identify VIPs' },
            { name: 'Real-Time Sales', benefit: 'Live business pulse' }
        ],
        mockupType: 'chart',
        color: '#f59e0b',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)'
    },
    {
        id: 'memo-heavy',
        name: 'Memo Master Bundle',
        tagline: 'Complete memo program management',
        description: 'Everything for running a professional memo program with tracking, automation, and dealer satisfaction.',
        perfectFor: 'Memo-heavy business model, consignment operations',
        timeline: '10-12 weeks',
        investment: 'High',
        featureIds: [
            'memo-tracking',
            'memo-extension-auto-approval',
            'consignment-tracking',
            'inventory-consignment-revenue',
            'dealer-dropship-fulfillment',
            'dealer-dashboard',
            'credit-limit-management'
        ],
        features: [
            { name: 'Memo Return Tracking', benefit: 'Track all borrowed diamonds' },
            { name: 'Auto-Approval Extensions', benefit: 'Instant dealer satisfaction' },
            { name: 'Consignment Tracking', benefit: 'Know what\'s where' },
            { name: 'Revenue Share Automation', benefit: 'Automated settlements' },
            { name: 'Drop-Ship Fulfillment', benefit: 'Ship to dealer clients' },
            { name: 'Dealer Dashboard', benefit: 'Self-service convenience' },
            { name: 'Credit Management', benefit: 'Secure lending' }
        ],
        mockupType: 'workflow',
        color: '#8b5cf6',
        gradient: 'linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)'
    },
    {
        id: 'high-volume-wholesale',
        name: 'High-Volume Wholesaler',
        tagline: 'Built for bulk business and large orders',
        description: 'Volume pricing, multi-location shipping, inventory pooling, and everything for serious wholesalers.',
        perfectFor: 'High-volume dealers, multi-location businesses, bulk buyers',
        timeline: '8-10 weeks',
        investment: 'Medium',
        featureIds: [
            'bulk-purchase-discounts',
            'volume-pricing-tiers',
            'split-shipment-locations',
            'auto-repricing',
            'inventory-sync',
            'supplier-portal',
            'dealer-exclusive-promos',
            'price-match-guarantee'
        ],
        features: [
            { name: 'Bulk Discounts', benefit: 'Costco-style volume pricing' },
            { name: 'Volume Pricing Tiers', benefit: 'Clear discount structure' },
            { name: 'Split Shipment', benefit: 'Ship to multiple stores' },
            { name: 'Auto-Repricing', benefit: 'Always competitive' },
            { name: 'Inventory Sync', benefit: 'Real-time updates' },
            { name: 'Supplier Portal', benefit: 'Scalable sourcing' },
            { name: 'Dealer Promotions', benefit: 'Exclusive wholesale deals' },
            { name: 'Price Match', benefit: 'Guaranteed best price' }
        ],
        mockupType: 'grid',
        color: '#10b981',
        gradient: 'linear-gradient(135deg, #10b981 0%, #14b8a6 100%)'
    },
    {
        id: 'integration-hub',
        name: 'Integration Hub',
        tagline: 'Connect all your business tools',
        description: 'Seamless integration with CRM, accounting, shipping, and payments. Central hub for your tech stack.',
        perfectFor: 'Businesses with existing tools, workflow automation needs',
        timeline: '4-6 weeks',
        investment: 'Medium',
        featureIds: [
            'crm-integration',
            'accounting-sync',
            'shipping-integration',
            'payment-gateway',
            'zapier-integration',
            'google-shopping'
        ],
        features: [
            { name: 'CRM Integration', benefit: 'Salesforce, HubSpot sync' },
            { name: 'QuickBooks Sync', benefit: 'Automatic bookkeeping' },
            { name: 'Shipping Integration', benefit: 'FedEx, UPS, DHL' },
            { name: 'Payment Gateway', benefit: 'Accept cards, PayPal' },
            { name: 'Zapier Connection', benefit: '5000+ app integrations' },
            { name: 'Google Shopping', benefit: 'Product feed automation' }
        ],
        mockupType: 'network',
        color: '#6366f1',
        gradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'
    },
    {
        id: 'competitive-advantage',
        name: 'Competitive Advantage Pack',
        tagline: 'Features your competitors don\'t have',
        description: 'Unique capabilities that differentiate you: blockchain, territory rights, early access, price guarantees.',
        perfectFor: 'Standing out, unique market position, premium differentiation',
        timeline: '10-12 weeks',
        investment: 'High',
        featureIds: [
            'blockchain-provenance',
            'image-search',
            'virtual-trade-show-booth',
            'exclusive-territory-rights',
            'early-access-inventory',
            'price-match-guarantee',
            'seasonal-buying-guides',
            'predictive-alerts'
        ],
        features: [
            { name: 'Blockchain Tracking', benefit: 'Tamper-proof provenance' },
            { name: 'Image Recognition Search', benefit: 'Upload photo to search' },
            { name: 'Virtual Trade Show', benefit: 'Year-round exhibition' },
            { name: 'Territory Exclusivity', benefit: 'Protected dealer rights' },
            { name: 'Early VIP Access', benefit: '48-hour preview' },
            { name: 'Price Match', benefit: 'Guaranteed best price' },
            { name: 'Buying Guides', benefit: 'AI trend forecasts' },
            { name: 'Price Drop Alerts', benefit: 'Stock market tips' }
        ],
        mockupType: 'lightning',
        color: '#f97316',
        gradient: 'linear-gradient(135deg, #f97316 0%, #ef4444 100%)'
    },
    {
        id: 'marketplace-platform',
        name: 'Dealer Marketplace Platform',
        tagline: 'Create a thriving dealer ecosystem',
        description: 'Dealer-to-dealer trading, auctions, inventory pooling, and joint ventures. Build platform lock-in.',
        perfectFor: 'Platform strategy, network effects, dealer community',
        timeline: '14-18 weeks',
        investment: 'Very High',
        featureIds: [
            'private-dealer-marketplace',
            'dealer-diamond-swaps',
            'b2b-auction-platform',
            'live-wholesale-bidding',
            'dealer-collaboration-custom',
            'shared-inventory-pools'
        ],
        features: [
            { name: 'Private Marketplace', benefit: 'Dealers trade safely' },
            { name: 'Diamond Swaps', benefit: 'Peer-to-peer exchange' },
            { name: 'B2B Auctions', benefit: 'Wholesale lot bidding' },
            { name: 'Live Bidding', benefit: 'Dutch auction excitement' },
            { name: 'Joint Orders', benefit: 'Co-invest in expensive pieces' },
            { name: 'Shared Inventory', benefit: 'Co-op buying power' }
        ],
        mockupType: 'network',
        color: '#14b8a6',
        gradient: 'linear-gradient(135deg, #14b8a6 0%, #0ea5e9 100%)'
    },
    {
        id: 'trust-security',
        name: 'Trust & Security Foundation',
        tagline: 'Bank-level security for high-value transactions',
        description: 'Comprehensive security, compliance, and fraud prevention. Build ultimate customer confidence.',
        perfectFor: 'Compliance requirements, fraud prevention, enterprise security',
        timeline: '6-8 weeks',
        investment: 'Medium',
        featureIds: [
            'blockchain-provenance',
            'gia-integration',
            'cert-verification',
            'insurance-integration',
            'audit-trail',
            'gdpr-compliance',
            'ip-whitelisting'
        ],
        features: [
            { name: 'Blockchain Tracking', benefit: 'Immutable records' },
            { name: 'GIA API Integration', benefit: 'Instant verification' },
            { name: 'Certificate Tool', benefit: 'Public trust building' },
            { name: 'Insurance Integration', benefit: 'Protection offers' },
            { name: 'Audit Trail', benefit: 'Compliance logging' },
            { name: 'GDPR Tools', benefit: 'Privacy compliance' },
            { name: 'IP Whitelisting', benefit: 'Access control' }
        ],
        mockupType: 'checklist',
        color: '#ef4444',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
    },
    {
        id: 'marketing-growth',
        name: 'Marketing & Growth Engine',
        tagline: 'Acquire customers and grow revenue',
        description: 'Complete marketing toolkit: email, social, referrals, content, retargeting, and promotions.',
        perfectFor: 'Customer acquisition, brand building, revenue growth',
        timeline: '6-8 weeks',
        investment: 'Medium',
        featureIds: [
            'email-automation',
            'referral-program',
            'influencer-portal',
            'social-auto-post',
            'retargeting-pixels',
            'diamond-quiz',
            'seasonal-promos',
            'content-cms',
            'dealer-coop-marketing'
        ],
        features: [
            { name: 'Email Automation', benefit: 'Drip campaigns, cart recovery' },
            { name: 'Referral Program', benefit: 'Viral customer growth' },
            { name: 'Influencer Portal', benefit: 'Social media reach' },
            { name: 'Social Auto-Post', benefit: 'Consistent presence' },
            { name: 'Retargeting Pixels', benefit: 'Recover abandoners' },
            { name: 'Diamond Quiz', benefit: 'Lead capture funnel' },
            { name: 'Seasonal Promos', benefit: 'Holiday sales automation' },
            { name: 'Content CMS', benefit: 'SEO & thought leadership' },
            { name: 'Co-Op Marketing Fund', benefit: 'Dealer advertising support' }
        ],
        mockupType: 'chart',
        color: '#ec4899',
        gradient: 'linear-gradient(135deg, #ec4899 0%, #f472b6 100%)'
    },
    {
        id: 'global-expansion',
        name: 'Global Expansion Kit',
        tagline: 'Go international with confidence',
        description: 'Multi-language, multi-currency, regional compliance, and localized certifications for worldwide operations.',
        perfectFor: 'International expansion, global dealer network, overseas markets',
        timeline: '6-8 weeks',
        investment: 'High',
        featureIds: [
            'multi-language',
            'multi-currency',
            'exclusive-territory-rights',
            'dealer-showroom-scheduling'
        ],
        features: [
            { name: 'Multi-Language', benefit: '5+ languages with RTL' },
            { name: 'Multi-Currency', benefit: 'Accept global payments' },
            { name: 'Territory Rights', benefit: 'Regional exclusivity' },
            { name: 'Showroom Scheduler', benefit: 'International visits' }
        ],
        mockupType: 'globe',
        color: '#0ea5e9',
        gradient: 'linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%)'
    }
];
export const BUNDLE_CATEGORIES = [
    'All Bundles',
    'By Investment',
    'By Timeline',
    'By Use Case'
];
